import { useQuery } from "convex/react";
import { api } from "convex/_generated/api";

export interface User {
  id: string;
  displayName: string;
  isGuest: boolean;
  email?: string;
  emailVerified?: boolean;
}

export function useUser() {
  const authUser = useQuery(api.users.getCurrentUser);

  // Determine loading and authentication state
  const isLoading = authUser === undefined;
  const isAuthenticated = authUser !== null && authUser !== undefined;

  // Only authenticated users are allowed - no guests
  const user: User | null = isAuthenticated && authUser
    ? {
        id: authUser._id,
        displayName: authUser.displayName,
        email: (authUser as any).email,
        emailVerified: !!(authUser as any).emailVerificationTime,
        isGuest: false,
      }
    : null;

  return {
    user,
    isLoading,
    isAuthenticated,
  };
}
